import React from 'react';

import { useTranslation } from 'react-i18next';

import SmallStubPill from 'components/application/pills/SmallStubPill';
import Tooltip from 'components/application/Tooltip';

export default function ELearningCourseEnrolledPill() {
  const { t: i18nTBookings } = useTranslation('common', {
    keyPrefix: 'bookings',
  });

  return (
    <Tooltip
      placement='top'
      tooltip={i18nTBookings('eLearningEnrolled')}
      trigger='hover'
    >
      <SmallStubPill className='tw-bg-green-025 tw-align-middle tw-text-green-800'>
        {i18nTBookings('eLearningEnrolled')}
      </SmallStubPill>
    </Tooltip>
  );
}
